import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignoutComponent } from './components/signout/signout.component';
import { SignInComponent, SignUpComponent } from './pages';

const routes: Routes = [
    {
        path: 'sign-up',
        component: SignUpComponent,
        outlet: 'auth'
    },
    { path: 'sign-in', component: SignInComponent, outlet: 'auth' },
    { path: 'sign-out', component: SignoutComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule {}
